import { render, staticRenderFns } from "./ToDoListDueDateDialog.vue?vue&type=template&id=5e1669c0&scoped=true&"
import script from "./ToDoListDueDateDialog.vue?vue&type=script&lang=js&"
export * from "./ToDoListDueDateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e1669c0",
  null
  
)

export default component.exports